import axios from 'axios';
import { api, auth, database, fieldValue, functions } from './firebase';
import firebase from 'firebase';

const submitIP = async () => {
  const token = await auth.currentUser!.getIdToken();
  await axios(`${api}/logs/login`, {
    method: 'post',
    headers: { Authorization: `Bearer ${token}` },
    data: {
      displayName: auth.currentUser!.displayName,
    },
  });
};

export const register = async (email: string, password: string) => {
  try {
    await auth.createUserWithEmailAndPassword(email, password);
    await Promise.all([submitIP(), updateUsers()]);
  } catch (error) {
    return error.message;
  }
  return null;
};
export const loginWithGoogle = async () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  try {
    await auth.signInWithPopup(provider);
    await Promise.all([submitIP(), updateUsers()]);
  } catch (error) {
    return error.message;
  }
  return null;
};

export const loginWithFacebook = async () => {
  const provider = new firebase.auth.FacebookAuthProvider();
  try {
    await auth.signInWithRedirect(provider);
    await Promise.all([submitIP(), updateUsers()]);
  } catch (error) {
    return error.message;
  }
  return null;
};

export const loginWithEmail = async (email: string, password: string) => {
  try {
    await auth.signInWithEmailAndPassword(email, password);
    await submitIP();
  } catch (error) {
    return error.message;
  }
  return null;
};
export const updateDisplayName = async (displayName: string) => {
  try {
    await auth.currentUser?.updateProfile({ displayName });
    await updateUsers();
  } catch (error) {
    return error;
  }
  return null;
};
export const sendEmailResetPassword = async (email: string) => {
  try {
    var actionCodeSettings = {
      url: 'https://learncybersec.org/login',
      handleCodeInApp: true,
    };
    await auth.sendPasswordResetEmail(email, actionCodeSettings);
  } catch (error) {
    console.log(error.message);

    return error.message;
  }
  return null;
};

export const updateUsers = async () => {
  if (auth.currentUser) {
    const { uid, displayName, email, photoURL } = auth.currentUser;
    await database.collection('users').doc(auth.currentUser.uid).set({
      uid,
      displayName,
      email,
      photoURL,
      updatedAt: fieldValue.serverTimestamp(),
    });
  }
};
